import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import * as signalR from '@microsoft/signalr';
import { fetchAttachmentsByInvoice } from '../api/invoicesApi';

const HUB_URL = `${import.meta.env.VITE_API_URL}/hub/liverefresh`;

// Revenue-side twin of useReceiptsByExpense. Invoice attachment changes ride
// the UpdateInvoiceTable fire because the count is a projected field on the
// invoice row (same pattern as expenses → UpdateReceiptTable). Keeping the
// subscription here so the detail modal refreshes its preview if a new
// attachment lands without the parent list refetching first.
export default function useAttachmentsByInvoice(invoiceId) {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['invoice-attachments', invoiceId],
        queryFn: () => fetchAttachmentsByInvoice(invoiceId),
        enabled: invoiceId != null,
        retry: false,
    });

    useEffect(() => {
        if (invoiceId == null) return undefined;

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(HUB_URL, {
                accessTokenFactory: () =>
                    window.Clerk.session.getToken({ template: 'marginpal-api' }),
            })
            .withAutomaticReconnect()
            .build();

        connection.on('UpdateInvoiceTable', () => {
            queryClient.invalidateQueries({ queryKey: ['invoice-attachments', invoiceId] });
        });

        connection.start().catch(err => console.error('SignalR connection error:', err));

        return () => {
            connection.stop();
        };
    }, [queryClient, invoiceId]);

    return query;
}
